import type { FilterField, FilterOption } from '@/components/common/AdvancedFilter';
import type { GeoUnit } from '@/features/geo/types/geo.types';
import type { OrganizationItem } from '@/features/organization/types/organization.types';
import type { ReportingAuthority } from '@/features/users/types/user.types';
import {
  getCompanyDepartmentFilterFields,
  getGeoFilterFields,
  getReportingMemberFilterField,
} from '@/utils/filterFields';
import type { AppVersion } from '../types/appVersionCheck.types';

function toVersionOptions(versions: AppVersion[] | undefined): FilterOption[] {
  return (versions ?? []).map((item) => ({
    value: item.version,
    label: item.isCurrent ? `${item.version} (current)` : item.version,
  }));
}

interface AppVersionCheckFilterOptions {
  versions: AppVersion[] | undefined;
  reportingMembers: ReportingAuthority[] | undefined;
  companies: OrganizationItem[] | undefined;
  departments: OrganizationItem[] | undefined;
  divisions: GeoUnit[] | undefined;
  districts: GeoUnit[] | undefined;
  thanas: GeoUnit[] | undefined;
}

export function getAppVersionCheckFilterFields(
  values: Record<string, string>,
  options: AppVersionCheckFilterOptions,
): FilterField[] {
  return [
    {
      key: 'appVersion',
      label: 'App Version',
      type: 'select',
      placeholder: 'All Versions',
      options: toVersionOptions(options.versions),
    },
    ...getCompanyDepartmentFilterFields(options),
    getReportingMemberFilterField(options.reportingMembers),
    ...getGeoFilterFields(values, options),
  ];
}
